import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=9712986e&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=9712986e&prod&lang=css&"
import style1 from "./Chat.vue?vue&type=style&index=1&id=9712986e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9712986e",
  null
  
)

export default component.exports